const TeamV1 = [
  {
    version: '1',
    name: 'Hira Khan',
    image: 'https://ca.slack-edge.com/T4JUEB3ME-UG8U1EMQC-23707ef54cc3-512',
    title: 'Data Scientist',
    linkedin: 'https://www.linkedin.com/in/hira-shahid-991b1583/',
    github: 'Hira63S',
  },
  {
    version: '1',
    name: 'Rob Hamilton',
    image: 'https://ca.slack-edge.com/T4JUEB3ME-ULJ9DTDKL-246bfe8730a9-512',
    title: 'Data Scientist',
    linkedin: 'https://www.linkedin.com/in/rob1ham/',
    github: 'Rob1Ham',
  },
  {
    version: '1',
    name: 'Sheila Eichenberger',
    image: 'https://ca.slack-edge.com/T4JUEB3ME-UHZCNQY3Y-a25cb56e80d9-512',
    title: 'Web Developer',
    linkedin: 'N/A',
    github: 'EpiceneDev',
  },

  {
    version: '1',
    name: 'Connor R Sullivan',
    image: 'https://ca.slack-edge.com/T4JUEB3ME-ULVE6L3TJ-5b9eaad31d15-512',
    title: 'Web Developer',
    linkedin: 'n/a',
    github: 'crsullivan',
  },
  {
    version: '1',
    name: 'Gabriel Romero',
    image: 'https://ca.slack-edge.com/T4JUEB3ME-UEFKRMPCP-4d6c51049ae9-512',
    title: 'UX Designer',
    linkedin: 'www.linkedin.com/in/gabe-romero-design',
    github: 'n/a',
  },
  {
    version: '1',
    name: 'Levi Simpson',
    image: 'https://ca.slack-edge.com/T4JUEB3ME-UDCJB03RD-0e87fb5029cc-512',
    title: 'Team Lead',
    linkedin: 'n/a',
    github: 'Levi-Huynh',
  },
  {
    version: '1',
    name: 'Rudy Enriquez',
    image: 'https://ca.slack-edge.com/T4JUEB3ME-UD2LGR18A-7c6caf1a9c21-512',
    title: 'Data Scientist',
    linkedin: 'n/a',
    github: 'RNEnriquez',
  },
  {
    version: '1',
    name: 'Johana Luna',
    image: 'https://ca.slack-edge.com/T4JUEB3ME-ULJAKAQ66-88214d54e62a-512',
    title: 'Data Scientist',
    linkedin: 'https://www.linkedin.com/in/johanaluna/?locale=en_US',
    github: 'johanaluna',
  },
  {
    version: '1',
    name: 'Akak Almaz',
    image: 'https://ca.slack-edge.com/T4JUEB3ME-ULK6ULQ0J-b2b2713290b3-512',
    title: 'Web Developer',
    linkedin: 'n/a',
    github: 'Aakak',
  },
];

const TeamV2 = [
  // WEB
  {
    version: '2',
    name: 'Jessica Dosseh',
    image:
      'https://avatars2.githubusercontent.com/u/24831198?s=460&u=4e2d7a78a8d4ba798589a59075bb98cd1b0e7e26&v=4',
    title: 'Web Developer',
    linkedin: 'https://www.linkedin.com/in/jessicadosseh/',
    github: 'https://github.com/JessicaDosseh',
  },
  {
    version: '2',
    name: 'Tara Sherman',
    image:
      'https://avatars1.githubusercontent.com/u/44125075?s=460&u=0d892d66ffa3913439ffd4badbc0d4875f5ecd32&v=4',
    title: 'Web Developer',
    linkedin: 'https://www.linkedin.com/in/tarasherman/',
    github: 'https://github.com/taraSherman',
  },
  {
    version: '2',
    name: 'Carlos Turcios',
    image: 'https://ca.slack-edge.com/ESZCHB482-W0138D436D6-e0838d1d105e-512',
    title: 'Web Developer',
    linkedin: 'https://www.linkedin.com/in/carlos-turcios-b5051055/',
    github: 'https://github.com/CarlosETurcios',
  },
  {
    version: '2',
    name: 'Alexis Anderson',
    image: 'https://ca.slack-edge.com/ESZCHB482-W012BRNRD9C-a2e830df8d7f-512',
    title: 'Web Developer',
    linkedin: 'https://www.linkedin.com/in/alexis-anderson-530795196/',
    github: 'https://github.com/aanderson9313',
  },
  {
    version: '2',
    name: 'Vincent Adeniji',
    image: 'https://ca.slack-edge.com/ESZCHB482-W012BRP432S-5ca2303ff84a-512',
    title: 'Web Developer',
    linkedin: 'https://www.linkedin.com/in/vincent-adeniji-363008116/',
    github: 'https://github.com/TOSINNIJIS1',
  },

  // DS
  {
    version: '2',
    name: 'Stephen Plainte',
    image: 'https://ca.slack-edge.com/ESZCHB482-W012QNTLJ2Y-eded290f44d6-512',
    title: 'Data Scientist',
    linkedin: 'https://www.linkedin.com/in/stephenplainte/',
    github: 'https://github.com/FuriouStyles',
  },
  {
    version: '2',
    name: 'Ivan Santos',
    image: 'https://ca.slack-edge.com/ESZCHB482-W0138D56KRN-8828cd79a091-512',
    title: 'Data Scientist',
    linkedin: 'https://www.linkedin.com/in/ivan-santos-a3688624/',
    github: 'https://github.com/Skantastico',
  },
  {
    version: '2',
    name: 'Brandon Bruce',
    image: 'https://ca.slack-edge.com/ESZCHB482-W012H6NP04V-449729fd2101-512',
    title: 'Data Scientist',
    linkedin: 'https://www.linkedin.com/in/brandon-bruce-1538a21a8/',
    github: 'https://github.com/brucebra000',
  },

  // DS + TL 1
  {
    version: '2',
    name: 'Marvin Davila',
    image: 'https://ca.slack-edge.com/ESZCHB482-W012X6PSYDP-ec35dbf6dfdb-512',
    title: 'Team Lead',
    linkedin: 'https://www.linkedin.com/in/marvin-davila/',
    github: 'https://github.com/malexmad',
  },
  // WEB + TL 2
  {
    version: '2',
    name: 'Richard Lawson',
    image: 'https://ca.slack-edge.com/ESZCHB482-W012X6T9KT3-443632831451-512',
    title: 'Team Lead',
    linkedin: 'https://www.linkedin.com/in/lawsonarichard/',
    github: 'https://github.com/lawsonarichard',
  },
];

export { TeamV1, TeamV2 };
